import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Landing page (marketing)
import Landing from './pages/Landing';

// App pages
import Layout from './components/Layout';
import Movies from './pages/Movies';
import Settings from './pages/Settings';
import Test from './pages/Test';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00b4d8',
    },
    secondary: {
      main: '#90e0ef',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

// App Layout wrapper for /app/* routes
const AppRoutes = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Movies />} />
      <Route path="/movies" element={<Navigate to="/app" replace />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/test" element={<Test />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  </Layout>
);

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Marketing landing page */}
          <Route path="/" element={<Landing />} />

          {/* Main app (after login - for now accessible to all) */}
          <Route path="/app/*" element={<AppRoutes />} />

          {/* Redirect old routes to /app */}
          <Route path="/movies" element={<Navigate to="/app" replace />} />
          <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
          <Route path="/test" element={<Navigate to="/app/test" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
